import {buildQueryParams} from "../../utils";
import {useApi} from "../Api";
import {FilteredRequest, PagedResponse} from "../types/pagination";
import {FormSearchPeakModel, PeakEntityRequest, PeakEntityResponse} from "../types/peak";

export const usePeakRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/peak-rate";

    function getPeak(peakId: number): Promise<PeakEntityResponse> {
        return GET(`${PATH}?id=${peakId}`);
    }

    function putPeak(peak: PeakEntityResponse): Promise<PeakEntityResponse> {
        return PUT(`${PATH}`, peak);
    }

    function putPeakList(peakList: PeakEntityResponse): Promise<PeakEntityResponse> {
        return PUT(`${PATH}`, peakList);
    }

    function deletePeak(peakId: number): Promise<number> {
        return DELETE(`${PATH}?id=${peakId}`);
    }

    function terminatePeak(peakId: number): Promise<PeakEntityResponse> {
        return GET(`${PATH}/terminate?id=${peakId}`);
    }

    function postPeakList(peakList: PeakEntityRequest): Promise<PeakEntityResponse> {
        return POST(`${PATH}`, peakList);
    }

    function getPeakFiltered(request: FilteredRequest<PeakEntityResponse>): Promise<PagedResponse<PeakEntityResponse>> {
        return GET(`${PATH}/filter`, {
            params: request,
            paramsSerializer: buildQueryParams
        });
    }

    function getPeakPaged(filters: FormSearchPeakModel): Promise<PagedResponse<PeakEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getPeakInUse({peakId}: { peakId: number }): Promise<boolean> {
        return GET(`${PATH}/in-use?id=${peakId}`);
    }

    return {
        deletePeak,
        postPeakList,
        putPeakList,
        getPeakPaged,
        terminatePeak,
        getPeakInUse
    };
};
